// extracted by mini-css-extract-plugin
export default {"lpnest__title":"LpNest_lpnest__title__pucyg","lpnest":"LpNest_lpnest__HHgww","lpnest__text":"LpNest_lpnest__text__RubmU"};